var map = {
	"./0.png": "d977",
	"./1.png": "0ca1",
	"./2.png": "b9af",
	"./cards.png": "d656",
	"./cards/10_of_Clubs.svg.png": "ec49",
	"./cards/10_of_Diamonds.svg.png": "9fd4",
	"./cards/10_of_Hearts.svg.png": "fb53",
	"./cards/10_of_Spades.svg.png": "c43b",
	"./cards/11_of_Clubs.svg.png": "0e18",
	"./cards/11_of_Diamonds.svg.png": "40e4",
	"./cards/11_of_Hearts.svg.png": "2f49",
	"./cards/11_of_Spades.svg.png": "8073",
	"./cards/12_of_Clubs.svg.png": "74a2",
	"./cards/12_of_Diamonds.svg.png": "c0a4",
	"./cards/12_of_Hearts.svg.png": "aed8",
	"./cards/12_of_Spades.svg.png": "68e0",
	"./cards/13_of_Clubs.svg.png": "b5bb",
	"./cards/13_of_Diamonds.svg.png": "546b",
	"./cards/13_of_Hearts.svg.png": "9a29",
	"./cards/13_of_Spades.svg.png": "c125",
	"./cards/1_of_Clubs.svg.png": "6d00",
	"./cards/1_of_Diamonds.svg.png": "1198",
	"./cards/1_of_Hearts.svg.png": "137b",
	"./cards/1_of_Spades.svg.png": "1432",
	"./cards/2_of_Clubs.svg.png": "c053",
	"./cards/2_of_Diamonds.svg.png": "bd77",
	"./cards/2_of_Hearts.svg.png": "ff67",
	"./cards/2_of_Spades.svg.png": "208a",
	"./cards/3_of_Clubs.svg.png": "550c",
	"./cards/3_of_Diamonds.svg.png": "7aa7",
	"./cards/3_of_Hearts.svg.png": "931a",
	"./cards/3_of_Spades.svg.png": "276f",
	"./cards/4_of_Clubs.svg.png": "e673",
	"./cards/4_of_Diamonds.svg.png": "23ca",
	"./cards/4_of_Hearts.svg.png": "6001",
	"./cards/4_of_Spades.svg.png": "09a4",
	"./cards/5_of_Clubs.svg.png": "6d0b",
	"./cards/5_of_Diamonds.svg.png": "da27",
	"./cards/5_of_Hearts.svg.png": "7916",
	"./cards/5_of_Spades.svg.png": "ec0a",
	"./cards/6_of_Clubs.svg.png": "e62e",
	"./cards/6_of_Diamonds.svg.png": "6d55",
	"./cards/6_of_Hearts.svg.png": "70e3",
	"./cards/6_of_Spades.svg.png": "b1e9",
	"./cards/7_of_Clubs.svg.png": "45ce",
	"./cards/7_of_Diamonds.svg.png": "3ce6",
	"./cards/7_of_Hearts.svg.png": "ada8",
	"./cards/7_of_Spades.svg.png": "e49b",
	"./cards/8_of_Clubs.svg.png": "3be6",
	"./cards/8_of_Diamonds.svg.png": "5b29",
	"./cards/8_of_Hearts.svg.png": "3c76",
	"./cards/8_of_Spades.svg.png": "267e",
	"./cards/9_of_Clubs.svg.png": "0186",
	"./cards/9_of_Diamonds.svg.png": "d5a6",
	"./cards/9_of_Hearts.svg.png": "ff5a",
	"./cards/9_of_Spades.svg.png": "8f9b",
	"./cards/Black_joker.svg.png": "d1db",
	"./cards/Card_back.svg.png": "3d52",
	"./cards/Red_joker.svg.png": "ace5",
	"./crown.png": "370f",
	"./github.png": "359c",
	"./greenbackground.png": "0f69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";